import { Chip, ChipBackgroundColor, ChipSize } from "@amzn/stencil-react-components/chip";
import { Text } from "@amzn/stencil-react-components/text";
import React, { FC } from "react";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import { CHOOSE_DELIVERY_STRINGS } from "../choose-delivery.constants";

export const RecommendedChip: FC = () => (
  <Chip
    backgroundColor={ChipBackgroundColor.Green}
    size={ChipSize.ExtraSmall}
    data-testid="recommended-chip"
  >
    <Text fontSize="T100">{getString(`${CHOOSE_DELIVERY_STRINGS}.recommended`)}</Text>
  </Chip>
);
